const puzzle = {
  id: "e1Y0CnwiCjwTAQUWO0bP",
  name: "Looking for a spy",
  rebuses: [
    {
      style: {},
      clues: [
        {
          style: {
            width: "calc(32% - 10px)",
          },
          dependsOn: [],
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              id: "1e87a593-20bb-480a-a136-b434d1b827b4",
              type: "image",
              subtext: "",
              value: "eEoToDhJ.png",
            },
          ],
          subtext: "",
          id: "8dacbbdd-e687-4e39-a98a-63835c9b9ee9",
          helperText:
            "Lightsaber means Star Wars, ring means Lord of the Rings and wand means Harry Potter. Angel means good guy, devil means bad guy. Role or actor. Follow the circled images.",
          clueGroup: 0,
        },
      ],
      id: "08320c59-80e5-4816-ad86-b2ebcd608309",
      solutionInfo: {
        solvedText: "Ralph Fiennes",
        possibleSolutions: [
          {
            value: "Ralph Fiennes",
            id: "b9f55661-2f5f-411e-b594-f40dd6b58f4c",
          },
          {
            id: "0886c419-87ec-4b7a-934a-51c9778b3160",
            value: "Fiennes",
          },
        ],
        type: "text",
      },
    },
    {
      clues: [
        {
          style: {
            width: "calc(50% - 10px)",
          },
          clueValues: [
            {
              subtext: "",
              type: "text",
              id: "84680419-a831-4b2e-96d6-91f4ca7278c6",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "James Monroe",
            },
            {
              value: "Dying Hercules",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "653b55ac-4620-490c-88dd-f15b9d7d77c1",
              subtext: "",
            },
            {
              subtext: "",
              id: "e58f6bc4-92d2-4ff3-8bac-2ac4fb946d26",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "The Judgment of Jupiter",
            },
          ],
          dependsOn: [],
          solutionInfo: {
            type: "text",
            solvedText: "Morse",
            possibleSolutions: [
              {
                id: "3cb131b8-7328-4a16-ab9e-3f140bd4c7c6",
                value: "Morse",
              },
              {
                value: "Samuel Morse",
                id: "6cc8bba8-99bf-4b29-b69f-2fa2546b42f8",
              },
              {
                value: "Samuel Finley Breese Morse",
                id: "94273010-24df-47fb-a419-67cc77141642",
              },
            ],
          },
          subtext: "",
          id: "3d4369bc-0bd3-44b8-b109-3fec905850b6",
          clueGroup: 0,
          helperText: "These are all names of paintings. Who painted them?",
        },
        {
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          style: {
            width: "calc(50% - 10px)",
          },
          clueGroup: 0,
          clueValues: [
            {
              type: "text",
              value:
                ".- -.-. - --- .-. / .-- .... --- / .--. .-.. .- -.-- . -.. / .... .- -. ... / .-.. .- -. -.. .- / .. -. / .. -. --. .-.. --- ..- .-. .. --- ..- ... / -... .- ... - . .-. -.. ...",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "566695b9-62e7-4559-8d16-149d2eae350c",
              subtext: "",
            },
          ],
          id: "6d2abfe8-e934-4e6d-81ea-3dafb092e6dd",
          dependsOn: [
            {
              id: "d1999ee4-5ac9-45d3-b468-40e20d371992",
              value: "3d4369bc-0bd3-44b8-b109-3fec905850b6",
            },
          ],
          helperText: "Try to translate this Morse code, see what you get.",
          subtext: "",
        },
      ],
      style: {},
      id: "bb40bdc0-3294-45b7-92ba-a17ee0ff982c",
      solutionInfo: {
        possibleSolutions: [
          {
            id: "ea32f211-bdb4-477c-9ba5-4c777e3e1353",
            value: "Christoph Waltz",
          },
        ],
        solvedText: "Christoph Waltz",
        type: "text",
      },
    },
    {
      id: "a19d75a5-42f8-46e7-a146-9bed690a84d5",
      style: {},
      clues: [
        {
          clueGroup: 0,
          clueValues: [
            {
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "284251fa-f60b-4be1-9534-12e15f027915",
              value: "A0jIIWW9.png",
              subtext: "52°30'28.3N 13°26'08.0E",
            },
            {
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "333251fa-f60b-4be1-9534-12e1333315",
              value: "ca1DVafN.png",
              subtext: "",
            },
          ],
          dependsOn: [],
          id: "eb881ee6-92a5-489f-9415-70de9f82b59a",
          style: {
            width: "calc(33% - 10px)",
          },
          helperText:
            'Try seeing what is located at those coordinates. Get a good "street view" of the location.',
          subtext: "",
          solutionInfo: {
            type: "text",
            solvedText: "1968",
            possibleSolutions: [
              {
                value: "1968",
                id: "bd89a40a-2082-416a-8a92-0a7ec35f00ac",
              },
              {
                value: "1968.",
                id: "d20f5792-21a3-4723-9c0e-f9c066f540d0",
              },
            ],
          },
        },
        {
          clueGroup: 0,
          clueValues: [
            {
              id: "73076672-c643-425d-bc79-e9e0b7ff69d2",
              subtext: "",
              style: {
                width: "calc(50% - 10px)",
              },
              type: "image",
              value: "eXGkSm7J.png",
            },
            {
              id: "a6n76672-c113-422d-b339-e9447ff69d2",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
                fontSize: "14px",
                marginTop: "-20px",
              },
              type: "text",
              value: "1968.",
            },
            {
              id: "69d0c61e-95c0-4247-a532-16a9705a7d5c",
              subtext: "",
              value: "007",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
                fontSize: "50px",
              },
            },
          ],
          subtext: "",
          helperText: "Find out who was born in 1968 and played James Bond.",
          dependsOn: [
            {
              id: "da5861ca-51f0-4b35-ac61-c8f351b85f32",
              value: "eb881ee6-92a5-489f-9415-70de9f82b59a",
            },
          ],
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          style: {
            width: "calc(33% - 10px)",
            filter: "blur(27px)",
          },
          id: "63e471d8-5db1-4381-b801-c2b7ad419e85",
        },
      ],
      solutionInfo: {
        solvedText: "Daniel Craig",
        type: "text",
        possibleSolutions: [
          {
            value: "Daniel Craig",
            id: "5ede9c56-e4ad-4636-b087-e6200c2a3380",
          },
        ],
      },
    },
    {
      style: {},
      id: "403fc750-1417-4a05-8aa2-58ab0ed6b7aa",
      clues: [
        {
          id: "deba6ac6-1895-46d5-8fb9-6473d490b874",
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              id: "855795c2-c94b-4945-893f-e734b2b8003f",
              type: "text",
              value: "Ralph Fiennes",
            },
          ],
          style: {
            width: "calc(33% - 10px)",
          },
          clueGroup: 1,
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          subtext: "",
          helperText: "",
          dependsOn: [],
        },
        {
          clueValues: [
            {
              id: "08c7f271-efb3-4f3f-9083-89787de6e135",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Christoph Waltz",
              type: "text",
            },
          ],
          dependsOn: [],
          helperText: "",
          clueGroup: 1,
          id: "6d58235e-023a-4340-8192-02d0722d582c",
          subtext: "",
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          style: {
            width: "calc(33% - 10px)",
          },
        },
        {
          helperText: "",
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          dependsOn: [],
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              id: "b0caacbe-0aeb-482c-8a26-eee63ce79562",
              value: "Daniel Craig",
              type: "text",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          subtext: "",
          id: "1c44c32a-6112-4e34-8a2d-81d330f4fabb",
          clueGroup: 1,
        },
        {
          style: {
            width: "calc(33% - 10px)",
          },
          helperText: "What movie did those guys play in that year?",
          clueGroup: 1,
          subtext: "",
          dependsOn: [],
          clueValues: [
            {
              id: "429b4109-de2c-4b1e-8e67-c6cb3f6ec82a",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "2015",
              type: "text",
            },
          ],
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          id: "1d70e86e-fa76-4c57-9d82-691c703d6c4f",
        },
      ],
      solutionInfo: {
        type: "text",
        solvedText: "Spectre",
        possibleSolutions: [
          {
            id: "5a96d0a8-eecc-4c9d-a84d-49a1e7bc0a6f",
            value: "Spectre",
          },
        ],
      },
    },
  ],
};

export default puzzle;
